import { withChartLayout } from 'components/common';
import MusculoskeletalInterventions from 'components/features/chart/system-nursing-interventions/musculoskeletal-interventions/MusculoskeletalInterventions';

const MusculoskeletalInterventionsPage = withChartLayout('Musculoskeletal Interventions')(MusculoskeletalInterventions);
export default MusculoskeletalInterventionsPage;
